import { useState } from "react";
import { FiEdit } from "react-icons/fi";
import { TbEdit } from "react-icons/tb";
const InputComponent = ({
  label,
  value,
  symbol,
  first,
  switched,
  updateLtvConfiguration,
  flag,
}) => {
  const [openEdit, setOpenEdit] = useState(false);
  const [percent, setPercent] = useState("");

  return (
    <>
      <div
        className={` flex items-center justify-between w-full min-h-[31px] ${
          !first && "mt-8"
        } `}
      >
        <p className=" text-xs text-[#8b8b8b]">{label}</p>
        <div className=" flex items-center">
          <div
            className={`${
              switched && "flex-row-reverse"
            } border h-[31px]  bg-[#f3f3f3] rounded-lg px-[10px] text-xs font-medium text-[#505050] py-2 border-[#a8a8a8] flex items-center ${
              openEdit ? " w-[107px]" : "w-[54px] mr-[18px] "
            }  `}
          >
            <input
              disabled={!openEdit}
              placeholder={openEdit && "Enter Max ROI"}
              defaultValue={
                flag === "debt"
                  ? value.debt
                  : flag === "hybrid"
                  ? value.hybrid
                  : flag === "equities"
                  ? value.equities
                  : value.other_funds
              }
              className={` focus:outline-none bg-[#f3f3f3] placeholder:text-xs ${
                openEdit ? " w-full" : " w-[90%]"
              }`}
              onChange={(e) => setPercent(e.target.value)}
            />
            {!openEdit && (
              <p className={` ${switched && "mr-[2px]"}`}>{symbol}</p>
            )}
          </div>
          {!openEdit && (
            <button onClick={() => setOpenEdit(true)}>
              <TbEdit size={20} color="#7c7c7c" />
            </button>
          )}
        </div>
      </div>
      {openEdit && (
        <div className=" w-full flex justify-end mt-[14px] text-xs font-medium">
          <div className=" flex ">
            <button
              className="bg-[#00394d]  w-[96px] rounded h-6 text-[white] mr-[14px]"
              onClick={() => {
                updateLtvConfiguration(flag, value, percent);
                setOpenEdit(false);
              }}
            >
              Save Changes
            </button>
            <button
              onClick={() => setOpenEdit(false)}
              className=" text-[#00394d]"
            >
              Cancel
            </button>
          </div>
        </div>
      )}
    </>
  );
};
export default InputComponent;
